import PropTypes from 'prop-types';
import FacetTextInputs from './facet_text_inputs';

const FacetPowerSearch = ({ context }) => {
  const paramStore = context.getStore('ParamStore');

  const isInUse = () => {
    return (
      paramStore.isActive('kw_and') ||
      paramStore.isActive('kw_phrase') ||
      paramStore.isActive('kw_or') ||
      paramStore.isActive('kw_not')
    );
  };

  const getParam = (param) => {
    return paramStore.get(param);
  };

  const changeListener = (callback) => {
    paramStore.addChangeListener(callback);
  };

  const removeChangeListener = (callback) => {
    paramStore.removeChangeListener(callback);
  };

  const isParamActive = (param) => {
    return paramStore.isActive(param);
  };

  const setParam = (key, val) => {
    context.executeAction(window.LP.module('Searches').SearchActions.setParam, {
      key,
      val
    });
  };

  return (
    <FacetTextInputs
      isInUse={isInUse}
      getParam={getParam}
      changeListener={changeListener}
      removeChangeListener={removeChangeListener}
      isParamActive={isParamActive}
      setParam={setParam}
    />
  );
};

FacetPowerSearch.propTypes = {
  context: PropTypes.object
};

export default FacetPowerSearch;
